// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CustomerService = {};
// console.log("🚀 ~ CustomerService:", CustomerService);

CustomerService.getCustomerList = function (userInput) {
  const params = new URLSearchParams();
  params.append("pageSize", userInput?.pageSize);
  params.append(
    "pageIndex",
    userInput?.pageIndex === 0 ? 0 : userInput.pageIndex - 1
  );

  if (userInput?.customerid) {
    params.append("customerid", userInput.customerid);
  }
  if (userInput?.code) {
    params.append("code", userInput.code);
  }
  if (userInput?.name) {
    params.append("name", userInput.name);
  }
  if (userInput?.idNumber) {
    params.append("idNumber", userInput.idNumber);
  }
  if (userInput?.address) {
    params.append("address", userInput.address);
  }
  if (userInput?.birthDate) {
    params.append("birthDate", userInput.birthDate);
  }
  if (userInput?.motherMaidenName) {
    params.append("motherMaidenName", userInput.motherMaidenName);
  }

  return lossClient({
    url: `/Customer/search?${params.toString()}`,
    method: "get",
  });
};

export default CustomerService;
